import { template as template_89493050a063418baee1f9725a203cf5 } from "@ember/template-compiler";
import { CONSENT_CATEGORIES, parseDataGrailCookie, preferencesToCookieOptions } from '../utils/datagrail';
import { service } from '@ember/service';
import Component from '@glimmer/component';
export default class DgConsentCallbacks extends Component {
    @service
    currentPractice;
    @service
    session;
    @service
    store;
    constructor(){
        super(...arguments);
        this.initDatagrail();
    }
    initDatagrail = ()=>{
        if (typeof window === 'undefined') return;
        window.dgEvent ??= [];
        window.dgEvent.push({
            event: 'preference_callback',
            params: this.onPreferenceCallback
        });
        if (this.currentPractice.get('featureDatagrailSegmentConsentClients')) {
            window.dgEvent.push({
                event: 'initial_preference_callback',
                params: this.syncConsentPreferences
            });
        }
    };
    syncConsentPreferences = async ()=>{
        if (!this.session.currentClient) return;
        let pref;
        try {
            pref = await this.store.queryRecord('tracking-consent-preference', {});
        } catch  {
            return;
        }
        const cookiePrefs = parseDataGrailCookie();
        const effective = cookiePrefs ? CONSENT_CATEGORIES.reduce((acc, { dbKey, cookieKey })=>{
            acc[dbKey] = pref[dbKey] && (cookiePrefs[cookieKey] ?? true);
            return acc;
        }, {}) : pref;
        const needsSync = cookiePrefs && CONSENT_CATEGORIES.some(({ dbKey })=>effective[dbKey] !== pref[dbKey]);
        if (needsSync) {
            this.store.adapterFor('tracking-consent-preference').update(effective);
        }
        const preferences = preferencesToCookieOptions(effective);
        const cookieMatchesEffective = cookiePrefs && CONSENT_CATEGORIES.every(({ dbKey, cookieKey })=>effective[dbKey] === cookiePrefs[cookieKey]);
        if (!cookieMatchesEffective) {
            window.DG_BANNER_API?.setConsentPreferences(preferences, {
                runPreferenceCallbacks: false
            });
        }
    };
    onPreferenceCallback = (preferences)=>{
        if (!this.session.currentClient) return;
        if (!this.currentPractice.get('featureDatagrailSegmentConsentClients')) return;
        const { cookieOptions } = preferences.consentPreferences;
        this.store.adapterFor('tracking-consent-preference').update(CONSENT_CATEGORIES.reduce((acc, { dbKey, cookieKey })=>{
            acc[dbKey] = cookieOptions.find((o)=>o.gtm_key === cookieKey)?.isEnabled ?? true;
            return acc;
        }, {}));
    };
    static{
        template_89493050a063418baee1f9725a203cf5(`
    {{! intentionally renders nothing; this component exists to initialize DataGrail callbacks }}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
